/**
 * External dependencies
 */
import { Provider } from 'react-redux';

/**
 * Internal dependencies
 */
import createAppStore from '@naruto/bgdapp/src/providers/initializeStore';
import createAppModel from '@naruto/bgdapp/src/providers/initializeModel';
import createMiddleware from '@naruto/bgdapp/src/providers/initializeMiddleware';
import { ProviderProps, ReducerProvider } from './types';

export default function createProvider(config: ProviderProps): ReducerProvider {
  const initialMiddleWare = createMiddleware(config.middlewareConfig);
  const initialModel = createAppModel();
  const initialStore = createAppStore({ initialModel, initialMiddleWare });

  return { Provider, initialStore };
}
